import EventInterface from '@app/Interface/EventInterface';
import UserModel from '@app/Model/UserModel';
import EventHelper from '@app/Service/EventHelper';
import { Button, Card, CardBody, PageSection, Title } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import htmlParser from '@app/utils/htmlParser';

interface EventItemDetailProps {
    event: EventInterface,
    path: string,
    pageId: number,
    currentUser: UserModel,
}

const EventItemDetail: React.FC<EventItemDetailProps> = ({ event, path, pageId, currentUser }) => {
    return (
        <PageSection>
            <div>
                <Link to={{ pathname: path, search: '', state: { pageId: pageId, currentUser: currentUser } }}>&lt; Back</Link>
            </div>
            <Title headingLevel="h1" className="pf-u-mb-md">{event.title}</Title>
            <Card className="pf-u-mb-xl">
                <CardBody>
                    <p><strong>Event Date(s):</strong> {EventHelper.getEventDateString(event)}</p>
                    {event.eventLocation &&
                        <p><strong>Event Location:</strong> {event.eventLocation}</p>
                    }
                </CardBody>
                <CardBody>
                    <div className="pf-c-content">
                        {htmlParser.htmlToJSX(event.content ?? '')}
                    </div>
                </CardBody>
            </Card>
            <div>
                <Button
                    variant="primary"
                    component={props => <Link {...props} to={{ pathname: path, search: '', state: { pageId: pageId, currentUser: currentUser } }} />}
                >Back to events</Button>
            </div>
        </PageSection>
    );
};

export default EventItemDetail;